import React, { useState } from 'react'

import SidePanel from '../SidePanel/SidePanel'
import AuthNavBar from '../Dashboard/AuthNavBar'

function Analytics() {
	const [isPanelOpen, setIsPanelOpen] = useState(false)

	return (
		<div>
			<AuthNavBar />
			<SidePanel
				isOpen={isPanelOpen}
				onOpen={() => setIsPanelOpen(true)}
				onClose={() => setIsPanelOpen(false)}
			/>
			Analytics Page
		</div>
	)
}

export default Analytics
